import { Component, OnInit,Input } from "@angular/core";
import { EventoscomService } from '../../servicios/eventoscom.service';


@Component({
  selector: 'app-preguntas-front',
  templateUrl: './preguntas-front.component.html',
  styleUrls: ['./preguntas-front.component.css']
})
export class PreguntasFrontComponent implements OnInit {
  
  @Input() tipoPregunta: number;
  
  constructor(
    private eventoscomService: EventoscomService
  ) {}

  
  sendMessage(): void {
    // send message to subscribers via observable subject
    this.eventoscomService.sendMessage('Message from Home Component to App Component!');
    //////conole.log("funcionaaa");
}

clearMessage(): void {
    // clear message
    this.eventoscomService.clearMessage();
    //////conole.log("funcionaaa");
}
  
  
  
  
  ngOnInit() {
    
    
    //////conole.log(this.tipoPregunta);
    
    
  
    
  }


  funciontest(){
    //////conole.log("funcionaaa");
  }

  

}
